import { Clear, Logout, Repeat } from "@mui/icons-material";
import { Alert, Box, Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, FormControlLabel, Radio, RadioGroup, Typography } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import ConfirmationDialog from "../../components/Dialog/ConfirmationDialog";
import { useMemo, useState } from "react";
import { fetchBookingDetails, optOutRecurBooking } from "../../redux/actions/apiActions";
import { showAlert } from "../../redux/actions/commonActions";
import { setShowLoginForm } from "../../redux/actions/authActions";
import moment from "moment-timezone";

const RecurBookingOptOut = ({ recurringData }) => {

    const [showDialog, setShowDialog] = useState(false);
    const userData = useSelector(state => state.auth.userData);
    const bookingDetails = useSelector(state => state.api.bookingDetails);
    const [option, setOption] = useState("STOP_ALL");
    const dispatch = useDispatch();

    const onCloseDialog = () => {
        setShowDialog(false);
    }
    const onConfirmDialog = async () => {
        setShowDialog(false);
        const renewalOnly = option == "DISABLE_RENEWAL" ? true : false;
        if (bookingDetails?.recurringData?.enrollmentId) {
            await dispatch(optOutRecurBooking(bookingDetails?.recurringData?.enrollmentId, renewalOnly));
            await dispatch(fetchBookingDetails(bookingDetails?.id));
        }
    }

    const handleButton = () => {
        const isAuthorisedUser = userData?.id &&
            (
                userData?.id === bookingDetails?.customerId ||
                userData?.email === bookingDetails?.customerEmail ||
                userData?.telephone === bookingDetails?.customerPhoneNumber
            );

        if (isAuthorisedUser) {
            setShowDialog(true)
        } else {
            if (userData?.id) {
                dispatch(showAlert("error", "You are currently not allowed to opt-out this booking. Please login using Email/Phone number that used to book this appointment."))
            } else {
                dispatch(setShowLoginForm(true));
            }
        }
    }

    if (bookingDetails?.recurringData?.status !== "ACTIVE") return;


    return (
        <>
            <Button variant="outlined" sx={{ borderRadius: 5, gap: 1 }} onClick={handleButton} disabled={false}>
                <Logout /> Opt-Out Recurring
            </Button>
            <Dialog
                open={showDialog}
                onClose={onCloseDialog}
                aria-labelledby="stop-recurring-dialog-title"
                aria-describedby="stop-recurring-dialog-description"
                PaperProps={{ sx: { borderRadius: 3 } }}
                maxWidth="sm"
                fullWidth
            >
                <DialogTitle id="stop-recurring-dialog-title">
                    Manage Recurring Booking
                </DialogTitle>
                <DialogContent>
                    <Alert severity="warning" style={{ marginBottom: 20 }}>
                        This action affects <strong>future automatic bookings</strong> only.
                        Existing bookings that have already been created will remain unchanged.
                    </Alert>

                    <Typography variant="body2" color="textSecondary" gutterBottom>
                        Choose how you would like to stop recurring bookings.
                    </Typography>
                    <RadioGroup
                        value={option}
                        onChange={(e) => setOption(e.target.value)}
                    >
                        <Box
                            border={1}
                            borderColor="grey.300"
                            borderRadius={6}
                            p={2}
                            mb={2}
                        >
                            <FormControlLabel
                                value="STOP_ALL"
                                control={<Radio color="primary" />}
                                label={
                                    <Typography variant="subtitle1">
                                        Stop all future automatic bookings
                                    </Typography>
                                }
                            />

                            <Typography
                                variant="body2"
                                color="textSecondary"
                                style={{ marginLeft: 32 }}
                            >
                                Immediately stop this recurring booking plan.
                                No further bookings will be created automatically.
                                Renewal will also be disabled.
                            </Typography>
                        </Box>
                    {bookingDetails?.recurringData?.autoRenewalEnabled ? (
                        <Box
                            key="disable-renewal-option"
                            border={1}
                            borderColor="grey.300"
                            borderRadius={6}
                            p={2}
                        >
                            <FormControlLabel
                                value="DISABLE_RENEWAL"
                                control={<Radio color="primary" />}
                                label={
                                    <Typography variant="subtitle1">
                                        Disable renewal only
                                    </Typography>
                                }
                            />

                            <Typography
                                variant="body2"
                                color="textSecondary"
                                style={{ marginLeft: 32 }}
                            >
                                Continue creating automatic bookings for the
                                current recurring cycle. Once the current cycle
                                ends, it will not renew and no additional
                                automatic bookings will be generated.
                            </Typography>
                        </Box>
                    ) : (
                        null
                    )}
                    </RadioGroup>
                </DialogContent>

                <DialogActions>
                    <Button onClick={onCloseDialog}>
                        Cancel
                    </Button>
                    <Button
                        variant="contained"
                        onClick={onConfirmDialog}
                    >
                        Confirm
                    </Button>
                </DialogActions>
            </Dialog>
        </>
    )
}

export default RecurBookingOptOut;